import {ERoleId, RESPONSE_STATUS} from "../../const/dataEnum";
import {ModalType, TabId} from "../../pages/ManageEmployee/enum";
import {ManageEmployeeStateActions as actions} from '../../const/actionType';

const defaultId = -9999;

const initialState = {
  selectedTab: TabId.ACTIVE_EMPLOYEE,
  employees: [],
  practices: [],
  departments: [],
  authRoles: [],
  companies: [],
  roleLevels: [],
  sortValue: {
    sortBy: "fullName",
    sortType: "asc",
  },
  filterMap: {},
  totalItem: 0,
  pageSize: 10,
  pageNo: 0,
  pageIndex: 0,
  show: false,
  responseStatus: RESPONSE_STATUS.IDLE,
  newEmployee: {
    id: 0,
    fullName: null,
    authRoleID: ERoleId.TEAM_MEMBER,
    userName: null,
    departmentID: defaultId,
    practiceID: defaultId,
    roleLevelID: defaultId,
    roleDescription: null,
    joinDate: null,
    companyID: defaultId,
    lastDay: null,
    notes: null,
  },
  modalType: ModalType.CREATE,
};

const manageEmployeeStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_MODAL_TYPE: {
      return {
        ...state,
        modalType: action.modalType,
      }
    }
    case actions.SHOW_MODAL: {
      return {
        ...state,
        show: true,
      };
    }
    case actions.HIDE_MODAL: {
      return {
        ...state,
        show: false,
      };
    }
    case actions.SET_PRACTICES: {
      return {
        ...state,
        practices: action.practices,
      };
    }
    case actions.SET_AUTH_ROLES: {
      return {
        ...state,
        authRoles: action.authRoles,
      };
    }
    case actions.SET_COMPANIES: {
      return {
        ...state,
        companies: action.companies,
      };
    }
    case actions.SET_DEPARTMENTS: {
      return {
        ...state,
        departments: action.departments,
      };
    }
    case actions.SET_ROLE_LEVELS: {
      return {
        ...state,
        roleLevels: action.roleLevels,
      };
    }
    case actions.SET_NEW_EMPLOYEE: {
      return {
        ...state,
        newEmployee: {
          id: action?.newEmployee?.id,
          fullName: action?.newEmployee?.fullName,
          authRoleID: action?.newEmployee?.authRoleID,
          userName: action?.newEmployee?.userName,
          departmentID: action?.newEmployee?.departmentID,
          practiceID: action?.newEmployee?.practiceID,
          roleLevelID: action?.newEmployee?.roleLevelID,
          roleDescription: action?.newEmployee?.roleDescription,
          joinDate: action?.newEmployee?.joinDate,
          companyID: action?.newEmployee?.companyID,
          lastDay: action?.newEmployee?.lastDay,
          notes: action?.newEmployee?.notes,
        },
      };
    }
    case actions.SET_NEW_EMPLOYEE_BY_KEY: {
      return {
        ...state,
        newEmployee: {
          ...state.newEmployee,
          [action.key]: action.value,
        },
      };
    }
    case actions.SET_SORT_VALUE: {
      return {
        ...state,
        sortValue: action.sortValue
      };
    }
    case actions.SET_FILTER_MAP: {
      return {
        ...state,
        filterMap: action.filterMap
      };
    }
    case actions.SET_PAGE_NO: {
      return {
        ...state,
        pageNo: action.pageNo
      };
    }
    case actions.SET_PAGE_SIZE: {
      return {
        ...state,
        pageSize: action.pageSize
      };
    }
    case actions.SET_PAGE_INDEX: {
      return {
        ...state,
        pageIndex: action.pageIndex
      };
    }
    case actions.SET_TOTAL_ITEM: {
      return {
        ...state,
        totalItem: action.totalItem
      };
    }
    case actions.SET_RESPONSE_STATUS: {
      return {
        ...state,
        responseStatus: action.responseStatus
      };
    }
    case actions.SET_EMPLOYEES: {
      return {
        ...state,
        employees: action.employees
      };
    }
    case actions.RESET_NEW_EMPLOYEE: {
      return {
        ...state,
        newEmployee: initialState.newEmployee,
      }
    }
    case actions.SET_SELECTED_TAB: {
      return {
        ...state,
        selectedTab: action.selectedTab
      }
    }
    case actions.RESET_STATE: {
      return initialState;
    }
    case actions.SET_INITIAL_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default manageEmployeeStateReducer;

